import { get, put,Delete,post } from '../axios'

// 数据统计-省份数据
export const countProvince = params => get(`/web/home/data/count/province`,params);

// 数据统计-市份数据
export const countCity = params => get(`/web/home/data/count/city`,params);
